<template>
  <img v-if="isDark" src="./assets/unification-dark.svg" alt="unification">
  <img v-else src="./assets/unification.svg" alt="unification">
</template>

<script>
export default {
  name: 'emdMundiPagarmeUnificationImg',
  props: {
    isDark: {
      type: Boolean,
      default: false
    }
  }
}
</script>
